export default __webpack_public_path__ + "static/tanecni-kurzy-3-16c4cdd698bb6fa7ba6b370b6b0ad991.jpg";